
import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { observer } from 'mobx-react';

const _ContainCounsellors: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {

  const onPressTherapist = (answer: SnapshotOrInstance<IAnswerModel>) => {
    onPress(answer);
  };

  return children({
    questionId: question._id,
    questionKey: question.key,
    answers: question.answers,
    onPress: onPressTherapist,
  });

};


export const ContainCounsellors = observer(_ContainCounsellors);
